<template>
  <PageHeroAboutStyle
    :title="title"
    :background-image="backgroundImage"
    :breadcrumbs-label="breadcrumbsLabel"
  />
</template>

<script setup lang="ts">
const { t } = useI18n()

const title = computed(() => t('about.hero.title'))
const breadcrumbsLabel = computed(() => t('about.hero.breadcrumbText'))
const backgroundImage = '/assets/images/about/about-hero-bg.jpg'
</script>
